import './public-path';
import 'core-js';
import Renderer from 'utilities/Renderer';
import routes from './embed/routes';
import {analyticsInit} from 'utilities/analytics';
import {init as intlInit} from 'utilities/intl';
import {init as routerInit} from 'Router';
import {init as requestInit} from 'utilities/Request';
import './css/normalize.global.css';
import './css/app.embed.css';

requestInit({useDeveloperToken: true});

const store = Renderer.store;

analyticsInit(store);
intlInit().then(() => {
  const router = routerInit(routes);

  if (module.hot) {
    module.hot.accept(() => {
      router.listeners[0]();
    });
  }
});
